import React from 'react';
import Entities from 'html-entities/lib/html5-entities';
import Link from 'gatsby-link';
import { css, cx } from 'react-emotion';
import Color from 'color';

import { footerNavItems } from '../utils/config';
import { baselineGrid, colors, animation } from '../utils/presets';
import { adjustFontSizeTo } from '../utils/typography';
import { toRem, mqObj as mq } from '../utils/functions';

// Import components
import InnerWrapper from '../components/inner-wrapper';
import Mark from '../assets/svg-sprite/baseline-mark.svg';

const { speed, curve } = animation;

const entities = new Entities();

const linkColor = colors.accent.green;

const footer = css``;

const footerWrapper = css`
  /* max-width: ${toRem(baselineGrid * 144)}; */
`;

const footerInner = css`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column-reverse;
  padding: ${toRem(baselineGrid * 4)} 0;

  ${mq.lapLarge} {
    flex-direction: row;
    justify-content: space-between;
    padding: ${toRem(baselineGrid * 6)} 0;
  }
`;

const footerCell = css``;

const footerCopy = css`
  padding: ${toRem(baselineGrid * 2)} 0;

  ${mq.lapLarge} {
    padding: 0;
  }
`;

const copyright = css`
  ${adjustFontSizeTo(16)};
`;

const mark = css`
  display: inline-block;
  height: ${toRem(10)};
  width: auto;
  margin: 0 ${toRem(baselineGrid)} 0;
  vertical-align: baseline;
  fill: ${colors.pixelmoxie};
`;

const footerNav = css`
  ${adjustFontSizeTo(16)};
  margin-left: ${toRem(-baselineGrid)};
  padding: ${toRem(baselineGrid * 2)} 0;

  ${mq.lapLarge} {
    margin-left: 0;
    margin-right: ${toRem(-baselineGrid)};
    padding: 0;
  }
`;

const footerLink = css`
  position: relative;
  padding: 2px ${toRem(baselineGrid)};
  text-decoration: none;
  color: ${colors.gray.copy};
  transition: color ${speed.default} ${curve.default};

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: ${toRem(baselineGrid)};
    right: ${toRem(baselineGrid)};
    transition: opacity 200ms ease;
  }

  &::before {
    z-index: -2;
    top: 8%;
    bottom: 8%;
    opacity: 0;
    background-color: ${Color(linkColor)
      .hsl()
      .alpha(0.24)
      .string()};
  }

  &::after {
    z-index: -1;
    bottom: 8%;
    height: 2px;
    opacity: 1;
    background-color: ${linkColor};
  }

  &:hover,
  &:active,
  &:focus {
    &::before,
    &::after {
      opacity: 1;
    }
  }
`;

const Footer = () => (
  <footer className={footer}>
    <InnerWrapper className={footerWrapper}>
      <div className={footerInner}>
        <div className={cx(footerCell, footerCopy)}>
          <div className={copyright}>
            {entities.decode('&copy; 2018 Pixelmoxie')}
            <svg className={mark} viewBox={Mark.viewBox}>
              <use xlinkHref={`#${Mark.id}`} />
            </svg>
            {'Lovingly crafted Tumblr themes.'}
          </div>
        </div>
        <div className={cx(footerCell, footerNav)}>
          {footerNavItems.sort((a, b) => a.order - b.order).map((item, index) => (
            <Link key={index} to={item.path} className={footerLink}>
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </InnerWrapper>
  </footer>
);

Footer.propTypes = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js